import gql from 'graphql-tag';

export const albumMembershipGroupExists = gql`
  query albumMembershipGroupExists($id: RecordID!) {
    albumMembershipGroup(id: $id) {
      id
      display_name
    }
  }
`;
